import { Toast, Modal } from "antd-mobile";
import Utility from "UTIL/utility";
import $ from "jquery";
import { browserHistory } from "react-router";
import APIS from "SERVICE/APIs";
import nodeConfig from 'MODEL/config';

// var nodeConfig = require("../../package.json").webconfig;
var _domain = Utility.getOrigin() + "/" + nodeConfig.apiAddress;
if(__DEV__){
  _domain = nodeConfig.devApiAddress
}else{
  _domain = Utility.getOrigin() + "/" + nodeConfig.apiAddress;
}


class ApiService {
  apiServiceMethod(apimodule, apiname, type, params, mes, needStatus) {
    const deferred = $.Deferred();

    if (mes) {
      Toast.loading(mes, 0);
    } else {
      Toast.loading("加载中", 0);
    }
    let parameters = { param: params };
    const domain = _domain;

    var method = type.toUpperCase();
    if (["GET", "PUT", "POST", "DELETE", "OPTIONS"].indexOf(method) === -1) {
      return;
    }

    var finalUrl =
      domain +
      "/" +
      (apimodule == "" ? "" : apimodule + "/") +
      (apiname == "" ? "" : apiname);
    var queryString = [];
    var postdata;
    var i = 0;
    var len = parameters ? Object.keys(parameters).length : 0;

    if (parameters) {
      for (let x in parameters) {
        i++;
        if (i == len && typeof parameters[x] == "object") {
          postdata = JSON.stringify(parameters[x]);
          continue;
        }
        if (!parameters[x]) {
          continue;
        }
        queryString.push(x + "=" + encodeURI(parameters[x]));
      }
      if (queryString.length != 0) {
        finalUrl += "?" + queryString.join("&");
      }
    }
    /*
        if (excel) {
            return
        }
        */
    let userInfo = Utility.User.getUser();
    let userToken = "",
      ssoToken = "",
      partnerId = "";
    if (userInfo) {
      userToken = userInfo.userToken;
      ssoToken = userInfo.ssoToken;
      partnerId = userInfo.partnerId;
    }

    var headers = {
      "Content-Type": "application/json",
      "SARS-TOKEN-ID": window.blackbox ? window.blackbox : "",
      "X-SSO-Auth": ssoToken,
      "X-USER-Auth": userToken,
      "X-USER-Auth-PartnerId": partnerId,
      "X-KJT-Agent": ";;;;;;;default"
    };

    var deviceInfo = Utility.User.getUserInfoDevice();
    if (deviceInfo != "") {
      if (deviceInfo.kjtToken && deviceInfo.kjtToken != "") {
        headers["login-token"] = deviceInfo.kjtToken;
      }
      if (deviceInfo.deviceId && deviceInfo.deviceId != "") {
        headers["app-device-id"] = deviceInfo.deviceId;
      }
      if (deviceInfo.deviceType && deviceInfo.deviceType != "") {
        headers["app-device-type"] = deviceInfo.deviceType;
      }
    }

    var opt = {
      type: method,
      dataType: "json",
      url: finalUrl,
      headers: headers,
      timeout: 20000
    };
    if (postdata) {
      opt.data = postdata;
    }

    let tmp = $.ajax(opt)
      // .done(defer.resolve)
      .then(response => {
        if (response.status == 1004) {
          Toast.hide();
          Toast.info(response.message, 2);
          let _loginUrl = userInfo.loginUrl;

          setTimeout(function() {
            var uAgent = navigator.userAgent.toLowerCase();
            if (
              /iphone|ipad|ipod/.test(uAgent) &&
              typeof goAuthorize === "function"
            ) {
              goAuthorize();
            } else if (
              /android/.test(uAgent) &&
              typeof goAuthorize === "function"
            ) {
              goAuthorize();
            } else if (_loginUrl) {
              Toast.loading("", 0);
              location.href = _loginUrl;
            } else {
              let params = {
                type: "TokenLose", // type: 消息类型,必传
                messag: "MessageData" // 消息数据
              };
              // 发送消息给RN,postMessage()只能接受字符串
              window.postMessage(JSON.stringify(params)); // 发送消息到rn
            }
          }, 2000);
          return false;
        }
        if (response.status == 0) {
          Toast.hide();
          $(".am-toast").hide();
        } else {
          Toast.hide();
          if (!needStatus) {
            Toast.info(response.message, 2);
          }
        }
        if (needStatus) {
          deferred.resolve(response);
        } else {
          deferred.resolve(response.body);
        }
      })
      .fail(function(err) {
        Toast.hide();
        $(".am-toast").hide();
        Toast.info("网络异常，请稍后再试", 2);
      });
    return deferred.promise();
  }
}

export default new ApiService().apiServiceMethod;



// WEBPACK FOOTER //
// ./src/service/apiService.js